module.exports = __webpack_public_path__ + "img/wap_03.71a869f0.png";